import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { LOG_CONTEXT } from '@rms/core/http';
import { environment } from '@rms/env';
import { PageableParam, Paginated } from '@rms/sdk/models';
import { Observable } from 'rxjs';

import { Partner } from '../models';

@Injectable({
  providedIn: 'root',
})
export class PartnerApiService {
  private readonly http = inject(HttpClient);

  public getPartners({ page, size, sort }: PageableParam): Observable<Paginated<Partner>> {
    const params = new HttpParams({ fromObject: sort?.length ? { page, size, sort } : { page, size } });

    return this.http.get<Paginated<Partner>>(`${environment.apiEndpoint}/v1/im/partners`, {
      params,
      context: new HttpContext().set(LOG_CONTEXT, 'PartnerApiService.getPartners'),
    });
  }

  public getPartner(partnerId: string): Observable<Partner> {
    return this.http.get<Partner>(`${environment.apiEndpoint}/v1/im/partners/${partnerId}`, {
      context: new HttpContext().set(LOG_CONTEXT, 'PartnerApiService.getPartner'),
    });
  }
}
